import React, { useState } from "react";
import ProcurementMetricsAnylysis from "./GnaMetrics";

export default function MetricsProcurement({refreshKey} : { refreshKey:any }) {
  const [error, setError] = useState<string | null>(null);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  return (
    <>
      <ProcurementMetricsAnylysis
        selectedBlock={selectedBlock}
        refreshKey={refreshKey}
        setError={setError}
      />
    </>
  );
}
